import { useParams } from "react-router";
import { ProfileNav } from "../../../components/profileNav.component";
import { useState } from "react";
import { ProfileCard } from "../../../features/caregiver/profile/profileCard.component";
import { ApiCaregiver } from "../../../core/apis/caregiver";
import { PersonalInformation } from "../../../features/caregiver/profile/personalInformation";
import { CaregiverPatientList } from "../../../features/caregiver/profile/caregiverPatientList.component";
import { ComingSoon } from "../../../components/comingSoon.component";
import { CaregiverActivityLogCard } from "../../../features/caregiver/profile/activityLogCard.component";

export const PageSingleComponent = () => {
  const { caregiverId } = useParams<{ caregiverId: string }>();
  const { data, isValidating } = ApiCaregiver.ById.Hook(caregiverId);
  const [selectedPage, setSelectedPage] = useState("Personal Information");

  const pages: { [key: string]: string | JSX.Element } = {
    "Personal Information": (
      <PersonalInformation data={data} isValidating={isValidating} />
    ),
    "Patient List": (
      <CaregiverPatientList data={data} isValidating={isValidating} />
    ),
    "Activity Log": (
      <CaregiverActivityLogCard data={data} isValidating={isValidating} />
    ),
    "Financial Log": <ComingSoon />,
  };

  return (
    <>
      <ProfileCard data={data} isValidating={isValidating} />

      <ProfileNav
        items={[
          "Personal Information",
          "Patient List",
          "Activity Log",
          // "Financial Log",
        ]}
        active={selectedPage}
        onSelect={setSelectedPage}
      />

      {pages[selectedPage]}
    </>
  );
};
